import { Link } from 'react-router-dom';
import { ModuleLanding, Faq, SectionHead } from '../../shared/components/Common';
import Icon from '../../shared/components/Icons';
import { addDaysIso, img } from '../../shared/data/common';
import { popularRoutes } from './data';
import { busQueryString } from './searchModel';

const perks = [
  ['bus', 'Thousands of operators', 'AC sleepers, Volvo seaters and state transport buses'],
  ['check', 'Pick your seat', 'Live seat maps for every bus, upper and lower deck'],
  ['wallet', 'All-inclusive fares', 'Taxes included in every fare shown'],
  ['headset', '24x7 support', 'Help before and during your journey'],
];

const faqs = [
  ['Do I need to print my ticket?', 'Most operators accept the e-ticket on your phone. A few ask for a printout — this is shown on the bus and on your ticket.'],
  ['What ID do I need to carry?', 'Carry a valid government photo ID. Some operators need the ID type and number at booking; we ask for it only when they do.'],
  ['What are ladies seats?', 'Seats marked for women can only be booked for female passengers. Operators may refuse boarding otherwise.'],
  ['Can I cancel my ticket?', 'Yes, from My Trips. The refund depends on how long before departure you cancel — each bus shows its cancellation policy. The convenience fee is not refunded.'],
  ['When should I reach the boarding point?', 'At least 15 minutes before the boarding time shown on your ticket. The operator may call you before departure.'],
];

/** Results link for a popular route, travelling tomorrow. */
const routeLink = ([from, to]) => `/bus/results?${busQueryString({ from, to, date: addDaysIso(1) })}`;

export default function BusSearch() {
  return (
    <ModuleLanding tab="bus" title="Bus tickets" subtitle="Intercity buses across India · Live seat maps · Instant e-tickets" image={img('1544620347-c4fd4a3d5957', 1800)}>
      <section className="section container">
        <div className="perk-row">
          {perks.map(([ic, t, d]) => (
            <div key={t} className="perk"><span className="perk-icon"><Icon name={ic} size={22} /></span><div><b>{t}</b><span className="muted small">{d}</span></div></div>
          ))}
        </div>
      </section>

      <section className="section container">
        <SectionHead title="Popular routes" />
        <div className="route-grid three">
          {popularRoutes.map((route) => (
            <Link key={route.join('-')} to={routeLink(route)} className="route-card">
              <span className="route-icon"><Icon name="bus" size={20} /></span>
              <div className="route-info"><b>{route[0]}</b><span className="muted small">to {route[1]}</span></div>
              <div className="route-price"><span className="muted small">Tomorrow</span><b>View buses</b></div>
            </Link>
          ))}
        </div>
      </section>

      <section className="section container">
        <SectionHead title="Frequently asked questions" />
        <Faq items={faqs} />
      </section>
    </ModuleLanding>
  );
}
